import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

function MaintenanceFeed() {
  return (
    <div className="popover-content is-empty">
      <p className="u-text-center">
        <Icon type={['far', 'bell']} color="grey" size="5x" />
        Notifications center is currently under maintenance
      </p>
    </div>
  )
}

export default MaintenanceFeed
